import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { PurchaseOrdersToReceiveDataGrid } from "src/components/views/erp/purchase/reception/PurchaseOrdersToReceiveDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/purchase/purchaseOrdersToReceive")({
	staticData: { title: i18n.t("reception"), legacyViewKey: "purchaseOrdersToReceivePage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <PurchaseOrdersToReceiveDataGrid />;
}
